var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotInterestedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5H2.83333C2.36662 16.5 2.13327 16.5 1.95501 16.4092C1.79821 16.3293 1.67072 16.2018 1.59083 16.045C1.5 15.8667 1.5 15.6334 1.5 15.1667V1.5M15.6667 11.5L12.4009 8.01445C12.2772 7.88236 12.2153 7.81631 12.1406 7.78217C12.0747 7.75204 12.0021 7.73961 11.93 7.74611C11.8482 7.75348 11.7679 7.79519 11.6072 7.87861L8.89277 9.28806C8.73212 9.37148 8.65179 9.41319 8.57003 9.42055C8.49787 9.42706 8.42526 9.41463 8.35936 9.3845C8.28471 9.35036 8.22282 9.28431 8.09906 9.15221L4.83333 5.66667",
    stroke: "#050C46",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInterestedIcon);
export default __webpack_public_path__ + "static/media/notInterestedIcon.dde21fd084708cc6625528cbce53a5c1.svg";
export { ForwardRef as ReactComponent };